import { styled } from "@mui/material/styles"

import Row, { RowButColumnOnMobile } from "../Row"
import PageSizeSelector from "./PageSizeSelector"
import Pagination from "./Pagination"
import ResultsPositionFromTotal from "./ResultsPositionFromTotal"

export default function TablePaginationRow({
  tableRows,
  pageIndex,
  setPageIndex,
  pageSize,
  setPageSize,
  totalResultsSize,
  paginationDisabled,
}) {
  return (
    <PaginationContainer>
      <PageSizeSelector pageSize={pageSize} onPageSizeChange={setPageSize} />
      <RowButColumnOnMobile sx={{ gap: 2, alignItems: "center" }}>
        <ResultsPositionFromTotal
          rows={tableRows}
          pageIndex={pageIndex}
          pageSize={pageSize}
          totalCount={totalResultsSize}
        />
        <Pagination
          pageIndex={pageIndex}
          pageSize={pageSize}
          totalCount={totalResultsSize}
          onPageChanged={setPageIndex}
          disabled={paginationDisabled}
        />
      </RowButColumnOnMobile>
    </PaginationContainer>
  )
}

const PaginationContainer = styled(Row)(({ theme }) => ({
  justifyContent: "space-between",
  alignItems: "center",
  paddingTop: theme.spacing(2),
  gap: theme.spacing(2),
  [theme.breakpoints.only("xs")]: {
    alignItems: "flex-end",
    gap: 1,
  },
}))
